import React from 'react'
import classNames from 'classnames'

import { Button } from '@/components'
import { t } from '@/i18n'

import LoadingIndicator from '@/assets/images/loading_indicator.gif'

import { useSearch } from '../SearchContext'
import ModelFilter from './ModelFilter'

const SearchBox: React.FC = () => {
  const { text, onChangeText, loading } = useSearch()

  return (
    <div className="search-box">
      <ModelFilter />
      <div className="search-item">
        <label className="form-field">
          <input
            type="text"
            value={text || ''}
            placeholder={t('search')}
            onChange={(e: React.FormEvent<HTMLInputElement>) =>
              onChangeText(e.currentTarget.value)
            }
          />
        </label>
        <img
          className={classNames('search-loading-indicator', {
            searching: loading,
          })}
          src={LoadingIndicator}
        />
        <Button onClick={() => undefined}>
          <span className="icon-search"></span>
        </Button>
      </div>
    </div>
  )
}

export default SearchBox
